import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { User } from "lucide-react";

export default function Users() {
  const { data: users } = useQuery({ queryKey: ["users-directory"], queryFn: () => api.get("/users").then(r => r.data) });

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="label-eyebrow">Fællesskabet</div>
      <h1 className="hero-title text-4xl sm:text-5xl mt-2">Brugere</h1>
      <p className="mt-4 text-zinc-400 max-w-xl">Se alle spillere. Efter deadline kan du se hinandens forudsigelser.</p>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {users?.map(u => (
          <Link key={u.user_id} to={`/u/${u.user_id}`} className="card-flat p-5 interactive hover:-translate-y-0.5" data-testid={`user-card-${u.user_id}`}>
            <div className="flex items-center gap-4">
              {u.effective_picture ? (
                <img src={u.effective_picture} alt="" className="w-12 h-12 rounded-full object-cover" onError={e => e.currentTarget.style.display="none"} />
              ) : (
                <div className="w-12 h-12 rounded-full bg-zinc-800 flex items-center justify-center"><User size={16} className="text-zinc-500" /></div>
              )}
              <div className="min-w-0 flex-1">
                <div className="font-medium truncate">{u.display_name}</div>
                <div className="text-xs text-zinc-500 mt-0.5">{u.prediction_count} valg</div>
              </div>
            </div>
            {u.bio && <div className="mt-3 text-sm text-zinc-400 line-clamp-2">{u.bio}</div>}
          </Link>
        ))}
        {(!users || users.length === 0) && <div className="col-span-full card-flat p-10 text-center text-zinc-500">Ingen brugere endnu.</div>}
      </div>
    </div>
  );
}
